/* eslint-disable */
// src/components/VisitTransactionDetails/editVisitTransactionButton.js

import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { navigateEditVisitTransactionHelper } from "utils/navigateEditVisitTransactionHelper";
import PropTypes from "prop-types";

export default function EditVisitTransactionButton({
  visitId,
  local,
  profitPercentages,
  localMachineDetails,
  machines,
  lastCredits,
  displayDate,
  visitDateTime,
  lastLocalVisitBeforeId,
  lastLocalVisitBeforeDate,
  returnTo = null,
}) {
  const navigate = useNavigate();

  if (!visitId || !local?.Id) return null;

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() =>
        navigateEditVisitTransactionHelper(
          navigate,
          visitId,
          local,
          profitPercentages,
          localMachineDetails,
          machines,
          lastCredits,
          displayDate,
          visitDateTime,
          lastLocalVisitBeforeId,
          lastLocalVisitBeforeDate,
          returnTo
        )
      }
    >
      Editar la recaudación
    </Button>
  );
}
 EditVisitTransactionButton.propTypes = {  
   visitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,  
   local: PropTypes.shape({ Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired }).isRequired,  
   profitPercentages: PropTypes.array,  
   localMachineDetails: PropTypes.array,  
   machines: PropTypes.array,  
   lastCredits: PropTypes.array,  
   displayDate: PropTypes.string,  
   visitDateTime: PropTypes.string,
   lastLocalVisitBeforeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   lastLocalVisitBeforeDate: PropTypes.string,
   returnTo: PropTypes.shape({
     pathname: PropTypes.string,
     label: PropTypes.string,
   }),
 }; 
